import { ArrowUpCircle, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface Props {
  isOpen: boolean;
  message: string;
  onClose: () => void;
}

export function UpgradePlanModal({ isOpen, message, onClose }: Props) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-[2px] animate-in fade-in duration-150" onClick={onClose} />
      <div className="relative z-10 w-full max-w-sm mx-4 bg-white rounded-2xl shadow-2xl animate-in fade-in zoom-in-95 duration-150">
        <button onClick={onClose} className="absolute top-4 right-4 text-slate-400 hover:text-slate-600">
          <X className="h-5 w-5" />
        </button>

        <div className="flex flex-col items-center pt-8 pb-4 px-6">
          <div className="h-14 w-14 rounded-full bg-amber-50 flex items-center justify-center mb-4">
            <ArrowUpCircle className="h-7 w-7 text-amber-500" />
          </div>
          <h2 className="text-lg font-bold text-slate-900 text-center">Plan Limit Reached</h2>
          <p className="mt-2 text-sm text-slate-500 text-center leading-relaxed">{message}</p>
        </div>

        <div className="flex gap-3 px-6 pb-6 pt-2">
          <button
            onClick={onClose}
            className="flex-1 h-10 rounded-lg border border-gray-200 text-sm font-medium text-slate-600 hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={() => { onClose(); navigate('/choose-plan'); }}
            className="flex-1 h-10 rounded-lg bg-[#6366F1] hover:bg-[#4F46E5] text-white text-sm font-semibold transition-colors"
          >
            Upgrade Plan
          </button>
        </div>
      </div>
    </div>
  );
}
